import { render, staticRenderFns } from "./qrFrame.vue?vue&type=template&id=d0f480b6&scoped=true"
import script from "./qrFrame.vue?vue&type=script&lang=js"
export * from "./qrFrame.vue?vue&type=script&lang=js"
import style0 from "./qrFrame.vue?vue&type=style&index=0&id=d0f480b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f480b6",
  null
  
)

export default component.exports